module.exports = __webpack_public_path__ + "img/arrow_full_up_white.447403c8.svg";